import { useState, useCallback, useEffect } from 'react';
import {
  t as translate,
  loadLanguage,
  getLang,
  subscribe,
  fetchAvailableLanguages
} from '../utils/translator';

export const useTranslate = () => {
  const [state, setState] = useState({
    currentLang: getLang(),
    translations: {},
    availableLanguages: []
  });

  // Fetch available languages on mount
  useEffect(() => {
    fetchAvailableLanguages().then(languages => {
      setState(prev => ({ ...prev, availableLanguages: languages || [] }));
    });
  }, []);

  // Subscribe to translation changes
  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setState(prev => ({
        currentLang: getLang(),
        translations: {},
        availableLanguages: prev.availableLanguages || []
      }));
    });

    return unsubscribe;
  }, []);

  const changeLang = useCallback(async (lng) => {
    if (!lng || typeof lng !== 'string') {
      return;
    }
    await loadLanguage(lng);
    // Force immediate re-render after language change
    setState(prev => ({
      currentLang: getLang(),
      translations: {},
      availableLanguages: prev.availableLanguages || []
    }));
  }, []);

  const t = useCallback((key) => {
    return translate(key);
  }, [state.currentLang]);

  return {
    t,
    changeLang,
    currentLang: state.currentLang,
    availableLanguages: state.availableLanguages || []
  };
};
